import { AutoComplete, Button, Form, Input, InputNumber } from "antd";
import templatesStorage from "../../../storages/templatesStorage";
import { IDrone } from "@drone-parts.garphild.pro/interfaces";
import { useAtom } from "jotai";
import { selectedTemplateIdAtom } from "../../../atoms/selectedTemplateIdAtom";
import { PRODUCT_TYPE_MAP } from "../../../pages/drones-page/product-types";

interface IAddDroneDialogHeaderProps {
  drone: IDrone;
  onChange: (drone: IDrone) => void;
  generateId: () => void;
  searching: Record<string, string>;
  setSearching: (searching: Record<string, string>) => void;
  dronesModels: string[];
}

function AddDroneDialogHeader(
  {
    drone,
    onChange,
    generateId,
    searching,
    setSearching,
    dronesModels,
  }: IAddDroneDialogHeaderProps)
{
  const [selectedTemplate, setSelectedTemplate] = useAtom(selectedTemplateIdAtom);
  const productTypeConfig = PRODUCT_TYPE_MAP[drone.itemType || 'drone'];
  const filteredTemplates = templatesStorage.templates.filter(t => t.type === (drone.itemType || 'drone'));

  return (
    <>
      <AutoComplete
        value={drone.model}
        showSearch
        searchValue={searching.model}
        onSearch={(value) => {
          setSearching({
            ...searching,
            model: value,
          })
        }}
        style={{ width: '100%' }}
        onChange={(value) => {
          onChange({
            ...drone,
            model: value,
          });
        }}
        options={dronesModels
          .filter((model) => model?.toLowerCase().includes(searching?.model?.toLowerCase() || '') || !searching.model)
          .map((model) => ({ label: model, value: model }))
        }
      >
        <Input.Search
          placeholder={`${productTypeConfig?.label || 'Product'} model`}
          allowClear
          value={drone.model}
        />
      </AutoComplete>
      <AutoComplete
        value={templatesStorage.templates.find((template) => template._id === drone.template)?.title}
        showSearch
        searchValue={templatesStorage.templates.find((template) => template._id === drone.template)?.title}
        onSearch={(value) => {
          setSearching({
            ...searching,
            template: value,
          })
        }}
        style={{ width: '100%' }}
        onChange={(value) => {
          setSelectedTemplate(value);
          onChange({
            ...drone,
            template: value,
          });
        }}
        options={filteredTemplates
          .filter((template) => template.title.toLowerCase().includes(searching?.template?.toLowerCase() || '') || !searching.template)
          .map((template) => ({ label: template.title, value: template._id }))
        }
      >
        <Input.Search
          placeholder="Template"
          allowClear
          value={templatesStorage.templates.find((template) => template._id === drone.template)?.title}
        />
      </AutoComplete>
      <Input
        type="text"
        placeholder={productTypeConfig?.idPlaceholder || 'Product ID'}
        value={drone.droneId}
        style={{ marginBottom: 12 }}
        onChange={(e) => {
          onChange({
            ...drone,
            droneId: e.target.value,
          });
        }}
        addonAfter={drone.droneId ? null : (
          <Button
            onClick={() => {
              generateId();
            }}
          >
            Generate / {drone.droneId}
          </Button>
        )}
      />
    </>
  );
}

export default AddDroneDialogHeader;
